// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "@/assets/css/basic.css"
import ElementUI from 'element-ui';
import xhr from './common/xhr';
import 'element-ui/lib/theme-chalk/index.css';
// import "babel-polyfill";
Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.mixin({
  methods: {
    sendRequest:xhr.sendRequest
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js